import React from 'react';
import { Heading1, Heading3, Paragraph } from '../../components/typography';
import { Row, Col, Container } from '../../components/grid';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import TheVideoPlayer from '../../components/TheVideoPlayer';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="Video">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>
            Sådan sætter du plastikslange på en fadkobling
          </Heading1>
          <Paragraph>
            Et meget nemt og enkelt trick til når du skal skifte slange ved brug af klemmebånd og kogende vand.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <Row>
        <Col xs={12} padding="0">
          <TheVideoPlayer url="Fpn6cp73aOU" thumbnail="plastikslange-fadkobling" />
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3>
            Udskrift af video
          </Heading3>
          <Paragraph>
            Hvis omløberen ikke passer på den nye kobling må du klippe slangen.
            Det er nemmest at klippe slangen, hvis du lader koblingen sidde på fustagen.
            Sørg for at håndtaget ikke er trykket ned, så øllet ikke sprøjter ud.
          </Paragraph>
          <Paragraph>
            Brug en knibtang og skub klemmeringens åbning op, så den er nemmere at komme til.<br />
            Og tag klemmeringen af.<br />
            Klip i slangen og hiv den af.<br />
            Klip herefter slangens spids af.
          </Paragraph>
          <Paragraph>
            Slangen vil typisk være for hård til at sætte på igen eller på en ny kobling som her.<br />
            Sæt vand i kog.<br />
            Dyp slangen i det varme vand.<br />
            Tag klemmebåndet og sæt det på slangen og skub slangen på fadkoblingen.
          </Paragraph>
          <Paragraph>
            Skub klemmebåndet ned over slangen og koblingen og stram klemmebåndet med en bindetang eller en knibtang.
            Monter herefter kulsyreslangen.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
